import { Component, OnInit, ChangeDetectorRef, EventEmitter, Output, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HourglassService } from 'src/app/services/hourglass.service';

@Component({
  selector: 'app-form-tasks-entry',
  templateUrl: './form-tasks-entry.component.html',
  styleUrls: ['../hourglass.component.css']
})
export class FormTasksEntryComponent implements OnInit, OnChanges {
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  @Output() refreshData: EventEmitter<any> = new EventEmitter();
  @Output() useExistingTask: EventEmitter<any> = new EventEmitter();
  token!: string;
  _taskId: any;
  @Input()
  set taskId(value: number) { this._taskId = value; }
  get taskId(): number { return this._taskId; }

  currentCalEvent: any;
  errorMessage = "";
  listAssignees: any[] = [];
  listClients: any[] = [];
  listCategories: any[] = [];
  saveMode = "add";
  taskForm: any = {
    taskId: 0,
    taskName: "",
    taskDescription: "",
    taskActive: 1,
    taskType:0,
    category: "",
    clients: [],
    assignees: [],
    userId:0
  };
  userID: any = sessionStorage.getItem('wOSImpersonate') || sessionStorage.getItem('wOSAuthUser') || "";
  impersonatedUser: any = this.userID;
  taskMode = "add";
  private _pendingTaskData: any | null = null;
  constructor(
    private hourglassService: HourglassService,
    private changes: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const user: any = sessionStorage.getItem('wOSUser');
    this.token = JSON.parse(user).stsTokenManager.accessToken;

    $('#entryModal').on('shown.bs.modal', () => this.clearTask());

    this.hourglassService.getTimeEntryUxData(this.userID, 'all', null, this.token).then(r => {
      this.listCategories = r.categories;
      this.listClients = r.clients;
      this.listAssignees = r.assignees;

      if (this._pendingTaskData) {
        this.hydrateAssigneesForEdit(this._pendingTaskData);
        this._pendingTaskData = null;
      }
    });
  }

  loadFromAddButton(params: any): void {
    this.hourglassService.getTimeEntryUxData(this.userID, 'all', null, this.token).then(r => {
      this.listCategories = r.categories;
      this.listClients = r.clients;
      this.listAssignees = r.assignees;

      if (this._pendingTaskData) {
        this.hydrateAssigneesForEdit(this._pendingTaskData);
        this._pendingTaskData = null;
      }
    });
  }


  ngOnChanges(changes: SimpleChanges) {
    if (this._taskId > 0) {
      this.hourglassService.getTimeEntryTask(this._taskId, this.token).then(r => {
        const data = r[0];
        if (!data) return;

        this.saveMode = 'edit';
        this.taskForm.taskId = data.id;
        this.taskForm.taskName = data.t_name;
        this.taskForm.taskDescription = data.t_description;
        this.taskForm.taskActive = (data.active_flag == 1);

        this.taskForm.category = data.category_id;
        this.taskForm.clients = String(data.clientids || '')
          .split(',')
          .filter((s: string) => s !== '')
          .map((s: string) => Number(s));

        this.hydrateAssigneesForEdit(data);
      });
    }
  }

  loadFromCalendar(params: any): void {
    try {
      setTimeout(() => {
        this.currentCalEvent = params;
        this.taskForm.taskName = params.summary;
        $('#txt_taskdescription').trigger('focus');
      });
    } catch (ex) {
      console.log("loadfromcalendar error",ex)
    }
  }

  addNewTask(): void { this.taskMode = 'add'; }
  hideTaskModal(): void { this.useExistingTask.emit(this.currentCalEvent); }

  trackClients(client: any)   { return client.id; }
  trackAssignees(a: any)      { return a.id; }

  setFocus(): void { setTimeout(() => $('#txt_taskdescription').trigger('focus')); }

  private isTeam(a: any): boolean {
    return !!(a && (a.is_team === true || a.is_team === 1 || a.is_team === '1'));
  }

  private normalizeAssignee(a: any): any | null {
    if (typeof a === 'number') {
      return this.byUserId(a) || this.byTeamId(a) || null;
    }
    return a || null;
  }

  private toIntCsv(numbers: Array<number | string>): string | null {
    const items = numbers
      .map(n => String(n).trim())
      .filter(s => s !== '' && !isNaN(Number(s)) && Number(s) > 0);
    return items.length ? items.join(',') : null;
  }

  private parseCsvInts(csv: any): number[] {
    const s = (csv ?? '').toString().trim();
    if (!s) return [];
    return s.split(',')
            .map((x: string) => Number(x.trim()))
            .filter((n: number) => Number.isInteger(n) && n > 0);
  }

  private byUserId(id: number) {
    return (this.listAssignees || []).find((x: any) =>
      Number(x.id) === Number(id) && !this.isTeam(x)
    ) || null;
  }

  private byTeamId(id: number) {
    return (this.listAssignees || []).find((x: any) =>
      Number(x.id) === Number(id) && this.isTeam(x)
    ) || null;
  }

  private teamMemberSetFromTeamIds(teamIds: number[]): Set<number> {
    const out = new Set<number>();
    for (const tid of teamIds) {
      const team = this.byTeamId(tid);
      const csv = (team?.member_ids_csv || '').toString().trim();
      if (!csv) continue;
      for (const part of csv.split(',')) {
        const n = Number(part.trim());
        if (Number.isInteger(n) && n > 0) out.add(n);
      }
    }
    return out;
  }

  private hydrateAssigneesForEdit(taskData: any): void {
    if (!taskData || !this.listAssignees?.length) { this._pendingTaskData = taskData; return; }

    const rawTeamIds   = taskData.team_ids ?? taskData.teamList ?? '';
    const rawTeamNames = taskData.team_names ?? taskData.teamNames ?? '';
    const rawPersonCsv = taskData.assignee_ids ?? taskData.assignees ?? taskData.assigneeList ?? '';

    const hasTeamMeta = (rawTeamIds && String(rawTeamIds).trim() !== '') ||
                        (rawTeamNames && String(rawTeamNames).trim() !== '');

    const personIds = this.parseCsvInts(rawPersonCsv);

    if (!hasTeamMeta) {
      const selectedPeople = personIds.map(id => this.byUserId(id)).filter(Boolean);
      this.taskForm.assignees = [...selectedPeople];
      return;
    }

    const teamIds = this.parseCsvInts(rawTeamIds);
    if (!teamIds.length) {
      const selectedPeople = personIds.map(id => this.byUserId(id)).filter(Boolean);
      this.taskForm.assignees = [...selectedPeople];
      return;
    }

    const coveredByTeams = this.teamMemberSetFromTeamIds(teamIds);
    const individualsMinusTeams = personIds.filter(id => !coveredByTeams.has(id));

    const selectedTeams  = teamIds.map(id => this.byTeamId(id)).filter(Boolean);
    const selectedPeople = individualsMinusTeams.map(id => this.byUserId(id)).filter(Boolean);

    this.taskForm.assignees = [...selectedTeams, ...selectedPeople];
  }

  saveTask(): void {
    if (!this.taskForm.taskName) { this.errorMessage = 'Task name is required.'; this.clearErrorMessage(4500); $('#txt_taskname').trigger('focus'); return; }
    if (!this.taskForm.category) { this.errorMessage = 'Category is required.'; this.clearErrorMessage(4500); $('#sel_taskcategories').trigger('focus'); return; }
    if (!this.taskForm.clients?.length) { this.errorMessage = 'At least one client is required.'; this.clearErrorMessage(4500); $('#sel_taskclients').trigger('focus'); return; }
    if (!this.taskForm.assignees?.length) { this.errorMessage = 'At least one assignee is required.'; this.clearErrorMessage(4500); $('#sel_taskassignees').trigger('focus'); return; }

    const selectedObjs: any[] = (this.taskForm.assignees || [])
      .map((a: any) => this.normalizeAssignee(a))
      .filter(Boolean);

    let selectedPeople = selectedObjs.filter(a => !this.isTeam(a));
    const selectedTeams  = selectedObjs.filter(a =>  this.isTeam(a));

    const teamMembers = this.teamMemberSetFromTeamIds(selectedTeams.map((t:any)=>Number(t.id)));
    selectedPeople = selectedPeople.filter((p:any)=> !teamMembers.has(Number(p.id)));

    const badTeams = selectedTeams.filter((t: any) => !(t.member_ids_csv && String(t.member_ids_csv).trim() !== ''));
    if (badTeams.length) { this.errorMessage = 'One or more selected teams have no members.'; this.clearErrorMessage(4500); return; }

    const assigneesArray = [
      ...selectedPeople.map((p: any) => ({ id: Number(p.id), is_team: 0, member_ids_csv: null })),
      ...selectedTeams.map((t: any) => ({ id: Number(t.id), is_team: 1, member_ids_csv: (t.member_ids_csv || '').trim() || null }))
    ];

    const assigneeList = this.toIntCsv(selectedPeople.map((p: any) => p.id));  // USER ids
    const teamList     = this.toIntCsv(selectedTeams.map((t: any) => t.id));   // TEAM ids

    const payload: any = {
      taskId: this.taskForm.taskId || 0,
      taskName: this.taskForm.taskName,
      taskDescription: this.taskForm.taskDescription,
      taskActive: this.taskForm.taskActive ? 1 : 0,
      taskType: this.taskForm.taskType || 0,
      category: this.taskForm.category,
      clients: this.taskForm.clients,
      entity: 'task',
      mode: this.saveMode,
      clientList: (this.taskForm.clients || []).join(','),
      assignees: assigneesArray,
      assigneeList,
      teamList,
      userId: this.userID
    };

    this.hourglassService.saveTimeEntryEntity(payload, this.token)
      .then(r => this.closeModal.emit(r))
      .catch((ex) => {
        console.log("Save Entity Error ", ex)
      })
      .finally(() => {
        this.taskForm.entity = 'task';
        this.taskForm.mode = 'add';
        this.taskForm.category = '';
        this.taskForm.clients = [];
        this.taskForm.assignees = [];
        this.taskForm.userId = this.userID;
        this.taskForm.taskActive = 1;
      });
  }

  clearAll(filter: string): void {
    if (filter == 'assignees') this.taskForm.assignees = [];
    if (filter == 'clients')   this.taskForm.clients = [];
  }

  clearTask(): void {
    try {
      this.saveMode = 'add';
      this.taskForm.taskName = '';
      this.taskForm.taskDescription = '';
      this.taskForm.category = '';
      this.taskForm.assignees = [];
      this.taskForm.clients = [];
      this.taskForm.taskActive = 1;
      setTimeout(() => $('#sel_tasktype').trigger('focus'));
    } catch (ex) {
      console.log("clear task error",ex)
    }
  }

  clearAddTask(): void {
    console.log("clearAddTask")
    setTimeout(() => {
      this.taskForm.taskName = '';
      this.taskForm.taskDescription = '';
      this.taskForm.category = '';
      this.taskForm.assignees = [];
      this.taskForm.clients = [];
      this.taskForm.taskActive = -1;
      $('#txt_taskname').trigger('focus');
    });
  }

  selectAll(filter: string): void {
    if (filter == 'assignees') {
      const employeesOnly = (this.listAssignees || []).filter(a => !this.isTeam(a));
      this.taskForm.assignees = [...employeesOnly];
      return;
    }
    if (filter == 'clients') {
      const a: any[] = [];
      this.listClients.forEach((val: any) => a.push(val.id));
      this.taskForm.clients = a;
    }
  }

  clearErrorMessage(delay: number) {
    setTimeout(() => { this.errorMessage = ''; }, delay);
  }
}
